// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main_main__8k8Ga {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; }
  .main_main__logo__bXp0H {
    margin-top: -5%;
    width: 250px;
    margin-bottom: 45px; }
  .main_main__span__jlR\\+x {
    text-align: center;
    max-width: 490px;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 55px; }
  .main_main__start__pLcAs {
    margin-top: 10px;
    padding: 8px 36px;
    background: #fe6100;
    text-decoration: none;
    color: #fff;
    font-size: 14px;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.5s;
    border: none; }
    .main_main__start__pLcAs:hover {
      background: #ce3333; }
`, "",{"version":3,"sources":["webpack://./src/pages/main/main.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB,EAAA;EACnB;IACE,eAAe;IACf,YAAY;IACZ,mBAAmB,EAAA;EAErB;IACE,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB,EAAA;EAErB;IACE,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,YAAY,EAAA;IAVb;MAYG,mBAA4B,EAAA","sourcesContent":[".main {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  &__logo {\n    margin-top: -5%;\n    width: 250px;\n    margin-bottom: 45px;\n  }\n  &__span {\n    text-align: center;\n    max-width: 490px;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24px;\n    margin-bottom: 55px;\n  }\n  &__start {\n    margin-top: 10px;\n    padding: 8px 36px;\n    background: #fe6100;\n    text-decoration: none;\n    color: #fff;\n    font-size: 14px;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: all 0.5s;\n    border: none;\n    &:hover {\n      background: rgb(206, 51, 51);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `main_main__8k8Ga`,
	"main__logo": `main_main__logo__bXp0H`,
	"main__span": `main_main__span__jlR+x`,
	"main__start": `main_main__start__pLcAs`
};
export default ___CSS_LOADER_EXPORT___;
